import { useState } from 'react';

export const useRespNpsModal = () => {
  const [isShownRespNpsModal, setIsShownRespNpsModal] = useState<boolean>(false);
  const toggleRespNpsModal = () => setIsShownRespNpsModal(!isShownRespNpsModal);
  return {
    isShownRespNpsModal,
    toggleRespNpsModal,
  };
};
